import React from "react";

import type { IconProps } from "./BaseIcon";
import { BaseIcon } from "./BaseIcon";

export const ArrowLeftIcon: React.FC<IconProps> = ({ ...props }) => (
  <BaseIcon {...props}>
    <path d="M4.293 15.293a1 1 0 0 0 0 1.414l8.5 8.5a1 1 0 0 0 1.414-1.414L7.414 17H27a1 1 0 1 0 0-2H7.414l6.793-6.793a1 1 0 0 0-1.414-1.414l-8.5 8.5Z" />
  </BaseIcon>
);
